module.exports = __webpack_public_path__ + "img/csgo-banner.6492f89e.png";